import {
  useMap
} from "./chunk-OHKTFK4Q.mjs";
import {
  EventTargetContext
} from "./chunk-YH7PRLMG.mjs";

// src/overlay.tsx
import { useEffect } from "react";
import { jsx } from "react/jsx-runtime";
function Overlay(props) {
  const { element, children, autoMount = true } = props;
  const nmap = useMap();
  useEffect(() => {
    if (!autoMount) {
      return;
    }
    if (element.getMap() === nmap) {
      return;
    }
    element.setMap(nmap ? nmap : null);
    return () => {
      element.setMap(null);
    };
  }, [nmap]);
  return /* @__PURE__ */ jsx(EventTargetContext.Provider, {
    value: element,
    children
  });
}

export {
  Overlay
};
//# sourceMappingURL=chunk-IV7GZJYG.mjs.map